import React, { useState, useEffect, useContext } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import useQueries from '../../../database/useQueries';
import FormTemplate from '../../template/form/FormTemplate';
import { useSelector } from 'react-redux';
import LoadingOverlay from '../pagesMains/LoadingOverlay';
import { getFieldOptions } from '../plagins/data/commponentOptions';
import RowCreate from './rowCreate';
import CustomDialog from '../plagins/dialogs/customDialog';
import { DataContext, TemplateContext } from '../pagesMains/GravesManagers/Graves';
import { GlobalContext } from '../../../App';
import { v4 as uuidv4 } from 'uuid';
import { addRecordToCache, createFetchDataServer, getTableData } from '../../../database/fetchData';
import { fullSelectedAreaGraves, fullSelectedBlocks, fullSelectedCemeteries, fullSelectedPlots, fullSelectedRows } from '../plagins/data/multiSelectedForm';

const NAME_ENTITY = 'אחוזת קבר';

function GraveCreate() {
  // קבלת ערכים מהסטור
  const optionsFields = useSelector((state) => state.dataOptionsFieldsHe.data);
  const columnStore = useSelector((state) => state.columnsFormAreaGraves.data);
  const columns = useSelector((state) => state.columnsFormAreaGraves.data);

  const [columnsForm, setColumnsForm] = useState([]);

  const context = useContext(DataContext);
  const fetchDataServer = createFetchDataServer(context);

  // טעינת היוזים לפונקציות עזר
  const { addOrUpdateDataAreaGrave, getEntitiesByAttr, getEntityByAttr } = useQueries();

  // ערכי הראוטר
  const location = useLocation();
  const navigate = useNavigate();
  const { value } = location.state || {};

  const { setTotalWidthContainer } = useContext(TemplateContext);
  const { token, setTitle } = useContext(GlobalContext);

  useEffect(() => {
    setTotalWidthContainer(1200);
    setTitle(`אחוזות קבר`);
  }, [location.pathname]);

  // משתנים לערכי סלקט של השדות
  const [cemeteries, setCemeteries] = useState([]);
  const [blocks, setBlocks] = useState([]);
  const [plots, setPlots] = useState([]);
  const [rows, setRows] = useState([]);
  const [areaGraves, setAreaGraves] = useState([]);

  // איזור המשתנים והסטייטים
  // משתנים לטופס
  const [fieldsWithDynamicDisabled, setFieldsWithDynamicDisabled] = useState([]); // השדות
  const [formValues, setFormValues] = useState({}); // ערכי השדות
  const [errors, setErrors] = useState({}); // שגיאת השדות
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(true); // מצב טעינה
  // עוקב אחר שליחת נתונים לשרת דרך פונקציית סבמיט
  const [loadingData, setLoadingData] = useState(false);

  const myColumns = (localColumns = null) => {
    localColumns = localColumns !== null ? localColumns : columns;
    return localColumns.map((field, index) => {
      return {
        ...field,
        disabled: field.disabled && value !== undefined,
        required: field.required || false,
        show: field?.show || false
      };
    });
  };
  useEffect(() => {
    setFieldsWithDynamicDisabled(myColumns(columnStore));    
  }, []);

  // טעינת ערכים אוטומטית לשדות
  const fieldAuto = (data) => {
    setCemeteries(fullSelectedCemeteries(context?.contextCemeteries));
    if (data) {
      setPlots(fullSelectedPlots(getEntitiesByAttr(context?.contextPlots, 'blockId', data?.blockId)));
      setBlocks(fullSelectedBlocks(getEntitiesByAttr(context?.contextBlocks, 'cemeteryId', data?.cemeteryId)));
      setRows(fullSelectedRows(getEntitiesByAttr(context?.contextRows, 'plotId', data?.unicId), true, setOpen));
      setAreaGraves(getEntitiesByAttr(context?.contextAreaGraves, 'plotId', data?.unicId));
    } else {
      setBlocks(fullSelectedBlocks(context?.contextBlocks));
      setPlots(fullSelectedPlots(context?.contextPlots));
    }
  };

  const handleAllDataLoaded = () => {
    if (value?.unicId) {
      let initialFormValues = myColumns()
        .filter((field) => field?.name)
        .reduce(
          (acc, field) => {
            let fieldValue = value[field.name] || formValues[field.name] || '';
            return { ...acc, [field.name]: fieldValue };
          },
          {
            id: value?.id,
            unicId: value?.unicId
          }
        );

      initialFormValues = {
        cemeteryId: value?.cemeteryId,
        blockId: value?.blockId,
        plotId: value?.unicId
      };

      setFormValues((prevFormValues) => {
        return {
          ...prevFormValues, // ערכים קיימים
          ...initialFormValues, // ערכים חדשים
        }
      })
    }
    fieldAuto(value);
  };  

  // פעולות המתבצעות רק לאחר קבלת דאטה בייס ווליו מהראוטר
  useEffect(() => {
    handleAllDataLoaded();
  }, [context, navigator.onLine]);

  const fieldChangeCemeteryId = (event, newFormValues) => {
    delete newFormValues?.blockId;
    delete newFormValues?.plotId;
    delete newFormValues?.lineId;
    delete newFormValues?.areaGraveId;
    delete newFormValues?.graveId;
    delete newFormValues?.areaGraveNameHe;

    let blocks = context?.contextBlocks;
    let plots = context?.contextPlots;
    let rows = [];

    if (event?.target?.value && event.target.value !== null && event.target.value !== '') {
      blocks = getEntitiesByAttr(context?.contextBlocks, 'cemeteryId', event.target.value);
      plots = context?.contextPlots.filter((plot) => blocks.some((block) => block?.unicId === plot.blockId));
    }
    setBlocks(fullSelectedBlocks(blocks));
    setPlots(fullSelectedPlots(plots));
    setRows(rows);
  };
  const fieldChangeBlockId = (event, newFormValues) => {
    delete newFormValues?.plotId;
    delete newFormValues?.lineId;
    delete newFormValues?.areaGraveId;
    delete newFormValues?.graveId;
    delete newFormValues?.areaGraveNameHe;

    let cemeteryId = newFormValues?.cemeteryId;

    let blocks = fullSelectedBlocks(getEntitiesByAttr(context?.contextBlocks, 'cemeteryId', newFormValues?.cemeteryId));
    let plots = fullSelectedPlots(context?.contextPlots.filter((plot) => blocks.some((block) => block?.unicId === plot.blockId)));
    let rows = [];

    if (event?.target?.value && event.target.value !== null && event.target.value !== '') {
      plots = fullSelectedPlots(getEntitiesByAttr(context?.contextPlots, 'blockId', event.target.value));
      blocks = fullSelectedBlocks(getEntitiesByAttr(context?.contextBlocks, 'unicId', event.target.value));

      const block = getEntityByAttr(context?.contextBlocks, 'unicId', event.target.value);

      cemeteryId = block?.cemeteryId;
    }
    setPlots(plots);
    setRows(rows);
    return { cemeteryId };
  };
  const fieldChangePlotId = (event, newFormValues) => {
    delete newFormValues?.lineId;
    delete newFormValues?.areaGraveId;
    delete newFormValues?.graveId;
    delete newFormValues?.areaGraveNameHe;

    let cemeteryId = newFormValues?.cemeteryId;
    let blockId = newFormValues?.blockId;

    let blocks = fullSelectedBlocks(getEntitiesByAttr(context?.contextBlocks, 'unicId', newFormValues?.blockId));
    let rows = [];
    let areaGraves = fullSelectedAreaGraves(getEntitiesByAttr(context?.contextAreaGraves, 'plotId', newFormValues?.areaGraveId));

    let plot = getEntityByAttr(context?.contextPlots, 'unicId', newFormValues?.plotId);

    if (event?.target?.value && event.target.value !== null && event.target.value !== '') {
      plot = getEntityByAttr(context?.contextPlots, 'unicId', event.target.value);

      cemeteryId = plot?.cemeteryId;
      blockId = plot?.blockId;

      blocks = fullSelectedBlocks(getEntitiesByAttr(context?.contextBlocks, 'unicId', plot?.blockId));
      rows = fullSelectedRows(getEntitiesByAttr(context?.contextRows, 'plotId', event.target.value), true, setOpen);
      areaGraves = fullSelectedAreaGraves(getEntitiesByAttr(context?.contextAreaGraves, 'plotId', event.target.value));
    }

    setBlocks(blocks);
    setRows(rows);
    setAreaGraves(areaGraves);

    return { ...newFormValues, blockId, cemeteryId };
  };
  const fieldChangeLineId = (event) => {
    if (event?.target?.value && event.target.value !== null && event.target.value !== '') {
      setAreaGraves(getEntitiesByAttr(context?.contextAreaGraves, 'lineId', event.target.value));
    }
  };

  // קבלת הקומות
  const getFloorAttributes = (obj) => {
    return Object.keys(obj)
      .filter((key) => key.startsWith('floor'))
      .reduce((result, key) => {
        result[key] = obj[key];
        return result;
      }, {});
  };
  // הסרת הקומות
  const removeFloorAttributes = (obj) => {
    const newObj = { ...obj };
    Object.keys(newObj).forEach((key) => {
      if (key.startsWith('floor')) {
        delete newObj[key];
      }
    });
    return newObj;
  };
  // הפיכה לאובייקט
  const convertToObjectArray = (obj) => {
    return Object.keys(obj)
      .filter((key) => key.startsWith('floor'))
      .map((key) => ({
        name: key,
        ...obj[key]
      }));
  };

  const handleChange = (event) => {
    let newFormValues = formValues;
    const { name, value } = event.target;

    if (name.startsWith('floor')) {
      setFormValues({ ...formValues, [name]: value });
      return;
    }

    if (name === 'addFloor') {
      // השדות של הקברים שמתווספים
      let columnsGraves = [];
      let data = getEntityByAttr(context?.contextAreaGraves, 'unicId', formValues);

      // מציאת הערך האחרון של name
      const getLastFloorNumber = (arr) => {
        // Iterate over each item in the array
        const floorNumbers = arr.map((item) => {
          // Find the key that starts with 'floor'
          const floorKey = Object.keys(item).find((key) => key.startsWith('floor'));

          // Extract the number from the key
          if (floorKey) {
            const match = floorKey.match(/^floor(\d+)$/);
            return match ? parseInt(match[1], 10) : 0;
          }
          return 0;
        });

        // Return the maximum number found
        return Math.max(...floorNumbers);
      };

      // // פונקציה למציאת האות העברית האחרונה לפי יוניקוד
      const getLastHebrewLetter = (arr) => {
        const hebrewLetters = arr.map((item) => {
          const key = Object.keys(item).find((k) => k.startsWith('floor'));
          return key ? item[key].graveNameHe.charCodeAt(item[key].graveNameHe.length - 1) : 1487;
        });

        const maxUnicode = Math.max(...hebrewLetters);
        const nextLetter = String.fromCharCode(maxUnicode + 1);

        return nextLetter;
      };

      let temp = Object.keys(formValues)
        .filter((key) => key.startsWith('floor'))
        .map((key) => ({ [key]: formValues[key] }));

      temp = temp?.length > 0 ? temp : [{}];

      const lastFloorNumber = getLastFloorNumber(temp);
      const lastHebrewLetterCode = getLastHebrewLetter(temp);

      // פונקציה להוספת הערך החדש
      const addNewFloor = () => {
        const newFloor = {
          id: Date.now(), // או כל דרך אחרת לייצר id ייחודי
          name: `floor${lastFloorNumber + 1}`,
          graveNameHe: lastHebrewLetterCode,
          required: true,
          width: 800,
          show: true,
          input: 'floors',
          notRepeat: true
        };
        data = {
          ...data,
          [`floor${lastFloorNumber + 1}`]: { plotType: 1, graveNameHe: lastHebrewLetterCode }
        };
        columnsGraves = [...columnsGraves, newFloor];
      };

      // הוספת הערך החדש למערך
      addNewFloor();

      setFieldsWithDynamicDisabled(myColumns([...fieldsWithDynamicDisabled, ...columnsGraves]));

      setFormValues({ ...formValues, [`floor${lastFloorNumber + 1}`]: { plotType: 1, graveNameHe: lastHebrewLetterCode } });
      return;
    }

    if (name === 'cemeteryId') {
      let res = fieldChangeCemeteryId(event, newFormValues);
    }
    if (name === 'blockId') {
      let res = fieldChangeBlockId(event, newFormValues);
      if (event.target.value !== '') {
        newFormValues = { ...newFormValues, cemeteryId: res?.cemeteryId };
      }
    }
    if (name === 'plotId') {
      let res = fieldChangePlotId(event, newFormValues);
      newFormValues = { ...newFormValues, cemeteryId: res?.cemeteryId, blockId: res?.blockId };
    }
    if (name === 'lineId') {
      fieldChangeLineId(event, newFormValues);
    }
    setFormValues({ ...newFormValues, [name]: value });
  };

  // בדיקת וולידציה
  const validateForm = () => {
    let tempErrors = {};
    let formIsValid = true;

    columns.forEach((field) => {
      if (field.required && !formValues[field.name]) {
        if (field.name !== 'addFloor') {
          tempErrors[field.name] = 'שדה חובה';
          formIsValid = false;
        }
        if (field.name === 'addFloor') {
          if (!Object.keys(getFloorAttributes(formValues)).length > 0) {
            tempErrors[field.name] = 'חובה להקים קומה אחת לפחות';
            formIsValid = false;
          }
        }
      }

      if (field.notRepeat && formValues[field.name]) {
        if (areaGraves.filter(ag => ag.lineId === formValues['lineId']).some((item) => item[field.name] === formValues[field.name])) {
          console.log(1, areaGraves);
          console.log(2, field.name);
          
          tempErrors[field.name] = `הערך ${formValues[field.name]} כבר קיים`;
          formIsValid = false;
        }
      }
    });

    setErrors(tempErrors);
    return formIsValid;
  };

  // שליחת הטופס
  const handleSubmit = async (event) => {
    event.preventDefault();
    // if (validateForm()) {
    //   setLoadingData(true);
    //   let newFormValues = { ...formValues };

    //   // הסרת הקומות מתוך מערך areGrave
    //   newFormValues = removeFloorAttributes(newFormValues);

    //   let tempAddGraves = [];

    //   delete newFormValues?.addFloor;
    //   delete newFormValues?.cemeteryNameHe;
    //   delete newFormValues?.blockNameHe;
    //   delete newFormValues?.plotNameHe;
    //   delete newFormValues?.cemeteryId;
    //   delete newFormValues?.blockId;
    //   delete newFormValues?.plotId;

    //   const unicId = uuidv4();

    //   // קבלת הקברים
    //   let floorsValues = convertToObjectArray(formValues);

    //   tempAddGraves = [
    //     ...floorsValues.map((floor, index) => {
    //       return {
    //         graveNameHe: floor.graveNameHe,
    //         graveStatus: 1,
    //         areaGraveId: unicId,
    //         plotType: floor.plotType,
    //         unicId: uuidv4()
    //       };
    //     })
    //   ];
      
    //   // הוספת unicId לערך השדות לפני השליחה
    //   let updatedFormValues = {
    //     ...newFormValues,
    //     insertGraves: tempAddGraves
    //   };      

    //   // שליחה לשרת עם הערך החדש
    //   let res = await addOrUpdateDataAreaGrave(updatedFormValues, unicId);
    //   if (res === 200) {
    //     updatedFormValues = { ...updatedFormValues, id: unicId, unicId: unicId,
    //       cemeteryId: formValues.cemeteryId, blockId: formValues.blockId, plotId: formValues.plotId,
    //       cemeteryNameHe: context?.contextCemeteries?.find((c) => c?.unicId === formValues.cemeteryId)?.cemeteryNameHe,
    //       blockNameHe: context?.contextBlocks?.find((b) => b?.unicId === formValues.blockId)?.blockNameHe,
    //       plotNameHe: context?.contextPlots?.find((p) => p?.unicId === formValues.plotId)?.plotNameHe,
    //       lineNameHe: context?.contextRows?.find((r) => r?.unicId === formValues?.lineId)?.lineNameHe
    //     };

    //     context?.setContextAreaGraves((prev) => {
    //       // בדיקה אם הערך קיים בסטייט
    //       const existingIndex = prev.findIndex((item) => item.unicId === updatedFormValues.unicId);

    //       if (existingIndex !== -1) {
    //         // אם הערך קיים, מעדכן אותו
    //         const updatedState = [...prev];
    //         updatedState[existingIndex] = { ...updatedState[existingIndex], ...updatedFormValues };

    //         return updatedState;
    //       } else {
    //         // אם הערך לא קיים, מוסיף אותו
    //         return [...prev, { ...updatedFormValues, availableSum: tempAddGraves?.length, purchasedSum: 0, buriedSum: 0, savedSum: 0, graveSum: tempAddGraves?.length }];
    //       }
    //     });

    //     context?.setContextGraves((prev) => {
    //       // העתקת הסטייט הנוכחי למערך חדש
    //       const updatedState = [...prev];          

    //       tempAddGraves?.forEach((item) => {
    //         // קריאה לפונקציה addRecordToCache עם האייטם
    //         addRecordToCache(item, 'dataGraves');

    //         // הוספה לסטייט
    //         const existingIndex = updatedState.findIndex((record) => record.unicId === item.unicId);
    //         if (existingIndex === -1) {
    //           updatedState.push(item); // הוספה אם לא קיים
    //         }
    //       });          
    //       // החזרת הסטייט המעודכן
    //       return updatedState;
    //     });

    //     setLoadingData(false);
    //     navigate(-1);
    //   }
    // }
    if (validateForm()) {
      setLoadingData(true);
      let newFormValues = { ...formValues };

      // הסרת הקומות מתוך מערך areGrave
      newFormValues = removeFloorAttributes(newFormValues);

      let tempAddGraves = [];

      delete newFormValues?.addFloor;
      delete newFormValues?.cemeteryNameHe;
      delete newFormValues?.blockNameHe;
      delete newFormValues?.plotNameHe;
      delete newFormValues?.cemeteryId;
      delete newFormValues?.blockId;
      delete newFormValues?.plotId;

      const unicId = uuidv4();

      // קבלת הקברים
      let floorsValues = convertToObjectArray(formValues);

      const cemeteryNameHe = context?.contextCemeteries?.find((c) => c?.unicId === formValues.cemeteryId)?.cemeteryNameHe
      const blockNameHe = context?.contextBlocks?.find((b) => b?.unicId === formValues.blockId)?.blockNameHe
      const plotNameHe = context?.contextPlots?.find((p) => p?.unicId === formValues.plotId)?.plotNameHe
      const lineNameHe = context?.contextRows?.find((r) => r?.unicId === formValues?.lineId)?.lineNameHe


      tempAddGraves = [
        ...floorsValues.map((floor, index) => {
          console.log(123,formValues);
          
          return {
            
            areaGraveNameHe: formValues?.areaGraveNameHe,
            cemeteryId: formValues?.cemeteryId,
            blockId: formValues?.blockId,
            plotId: formValues?.plotId,
            lineId: formValues?.lineId,
            cemeteryNameHe: cemeteryNameHe,
            blockNameHe: blockNameHe,
            plotNameHe: plotNameHe,
            lineNameHe: lineNameHe,

            graveNameHe: floor.graveNameHe,
            graveStatus: 1,
            areaGraveId: unicId,
            plotType: floor.plotType,
            unicId: uuidv4()
          };
        })
      ];
      
      // הוספת unicId לערך השדות לפני השליחה
      let updatedFormValues = {
        ...newFormValues,

        cemeteryId: formValues.cemeteryId, 
        blockId: formValues.blockId, 
        plotId: formValues.plotId,
        cemeteryNameHe: cemeteryNameHe,
        blockNameHe: blockNameHe,
        plotNameHe: plotNameHe,
        lineNameHe: lineNameHe,

        insertGraves: tempAddGraves
      };

      // שליחה לשרת עם הערך החדש
      let res = await addOrUpdateDataAreaGrave(updatedFormValues, unicId);
      if (res === 200) {
        updatedFormValues = { ...updatedFormValues, id: unicId, unicId: unicId,
          cemeteryId: formValues.cemeteryId, 
          blockId: formValues.blockId, 
          plotId: formValues.plotId,
          cemeteryNameHe: cemeteryNameHe,
          blockNameHe: blockNameHe,
          plotNameHe: plotNameHe,
          lineNameHe: lineNameHe,
        };

        context?.setContextAreaGraves((prev) => {
          // בדיקה אם הערך קיים בסטייט
          const existingIndex = prev.findIndex((item) => item.unicId === updatedFormValues.unicId);

          if (existingIndex !== -1) {
            // אם הערך קיים, מעדכן אותו
            const updatedState = [...prev];
            updatedState[existingIndex] = { ...updatedState[existingIndex], ...updatedFormValues };

            return updatedState;
          } else {
            // אם הערך לא קיים, מוסיף אותו
            return [...prev, { ...updatedFormValues, availableSum: tempAddGraves?.length, purchasedSum: 0, buriedSum: 0, savedSum: 0, graveSum: tempAddGraves?.length }];
          }
        });

        context?.setContextGraves((prev) => {
          // העתקת הסטייט הנוכחי למערך חדש
          const updatedState = [...prev];          

          tempAddGraves?.forEach((item) => {
            // קריאה לפונקציה addRecordToCache עם האייטם
            addRecordToCache(item, 'dataGraves');

            // הוספה לסטייט
            const existingIndex = updatedState.findIndex((record) => record.unicId === item.unicId);
            if (existingIndex === -1) {
              updatedState.push(item); // הוספה אם לא קיים
            }
          });          
          // החזרת הסטייט המעודכן
          return updatedState;
        });

        setLoadingData(false);
        navigate(-1);
      }
    }
  };

  // הסרת קומת קבר
  const deleteItem = (item) => {
    const tempColumns = fieldsWithDynamicDisabled.filter((p) => p?.name !== item?.name);

    let checkEntity = getEntityByAttr(context?.contextBurials, 'graveId', item?.unicIc) || getEntityByAttr(context?.contextPurchases, 'graveId', item?.unicIc);

    if (checkEntity) {
      alert('לא ניתן להסיר, קיים תיק מקושר');
    } else {
      setFieldsWithDynamicDisabled(myColumns(tempColumns));
      setFormValues((prev) => {
        let temp = { ...prev };
        delete temp[item.name];
        return temp;
      });
    }
  };

  const [isNewRow, setIsNewRow] = useState(false);

  useEffect(() => {
    if (!open && isNewRow) {
      console.log('נכנס');
      handleAllDataLoaded();
    } else {
      setIsNewRow(true);
    }
  }, [open]);

  const handleNewRowCreated = (newRow) => {
    console.log('כרגע לא פעיל');
  };

  useEffect(() => {
    // async function loadTableData() {
    //   const localTempData = await getTableData('myDatabase', 'myStore');
    //   if (localTempData) {
    //     const dataCemeteries = localTempData.find((item) => item.name === 'dataCemeteries');
    //     const dataBlocks = localTempData.find((item) => item.name === 'dataBlocks');
    //     const dataPlots = localTempData.find((item) => item.name === 'dataPlots');
    //     const dataRows = localTempData.find((item) => item.name === 'dataRows');
    //     const dataAreaGraves = localTempData.find((item) => item.name === 'dataAreaGraves');
    //     const dataPurchases = localTempData.find((item) => item.name === 'dataPurchases');
    //     const dataBurials = localTempData.find((item) => item.name === 'dataBurials');
    //     if (dataCemeteries && dataBlocks && dataPlots && dataRows && dataAreaGraves && dataPurchases && dataBurials) {
    //       // setLoading(false);
    //       fetchDataServer(['cemeteries', 'blocks', 'plots', 'rows', 'areaGraves', 'purchases', 'burials'], token);
    //     }
    //   } else {

    //     // fetchDataServerWithCallback(['graves'], token, handlePartialUpdate);
        
    //   }
    // }
    fetchDataServer(['cemeteries', 'blocks', 'plots', 'rows', 'areaGraves', 'purchases', 'burials'], token);
    // loadTableData();
  }, []);

  if (loadingData) return <LoadingOverlay />;

  return (
    <>
      <FormTemplate
        title={`הוספת ${NAME_ENTITY}`}
        btn={`שמור`}
        fields={fieldsWithDynamicDisabled}
        columns={fieldsWithDynamicDisabled}
        formValues={formValues}
        handleChange={handleChange}
        handleSubmit={handleSubmit}
        del={deleteItem}
        errors={errors}
        options={{
          cemeteryId: cemeteries,
          blockId: blocks,
          plotId: plots,
          lineId: rows,
          graveType: getFieldOptions('graveType', optionsFields),
          areaGraves
        }}
      />
      <CustomDialog open={open} handleClose={() => setOpen(false)} title={'הוספת שורה'}>
        <RowCreate plotId={formValues?.plotId || ''} onRowCreated={handleNewRowCreated} />
      </CustomDialog>
    </>
  );
}

export default GraveCreate;
